import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PermissionService } from 'src/app/services/permission.service';
import { AnimationOptions } from 'ngx-lottie';
import { CrudService } from 'src/app/services/crud.service';
import {ComSerService} from '../../shared/commanservice/com-ser.service';
import { CustomizeWorkspaceService } from 'src/app/Dialogs/customize-workspace/customize-workspace.service';
import { ProfileService } from 'src/app/pages/profile/services/profile.service';
declare var $: any;
@Component({
    selector: 'app-dash-layout',
    templateUrl: './dash-layout.component.html',
    styleUrls: ['./dash-layout.component.scss'],
    standalone: false
})
export class DashLayoutComponent implements OnInit {
  onLoopCompleteCalledTimes = 0;

  public imageUrl = environment.IMAGE_BACKET_URL;
  public username;
  public userProfilePic;  
  public permission;
  public openDrawer:boolean = false;
  isTach :boolean = false;
  workspacePermission : any
  hideLeadIcon:boolean = true;
  hidePaymentIcon:boolean = true;
  profileInfo:any=''

    // This is the option that uses the package's AnimationOption interface  
    options: AnimationOptions = {    
      path: "../../../assets/lottie/main_dp.json"
    };  

  //Coo
  constructor(
    private profileService: ProfileService,
    private ComSerService: ComSerService,
    public permissionService: PermissionService, private crudService: CrudService,
    private customizeWorkspaceService: CustomizeWorkspaceService, ) {
    if (localStorage.getItem('fname') != 'null') {
      this.username = localStorage.getItem('fname') + ' ' + localStorage.getItem('lname');
    } else {
      this.username = '';
    }
    
    this.userProfilePic = (!localStorage.getItem('profile_pic') || localStorage.getItem('profile_pic').includes('image_not_available')) ? '': this.imageUrl + localStorage.getItem('profile_pic');    
  }

  ngOnInit() {
    this.customizeWorkspaceService.workspaceCustomization$.subscribe(data => {
      if (!data) return;  
      const workSpaceData = data.data ? data.data : data;
      workSpaceData.forEach(element => {
        if (element.slug === "lead_management") {
          this.hideLeadIcon = element.active;
        }
        if (element.slug === "payments") {
          this.hidePaymentIcon = element.active;
        }
        
      });
  
    });
  
    this.permission = this.permissionService.retrivePermission();

    this.crudService.updateProfileImage.subscribe(res => {
      if (res) {
        this.userProfilePic = this.imageUrl + res;
      }
    });
    this.getMerchantProfile()
    this.loadAuthorizedWidget();
  }

  private loadAuthorizedWidget() {
    const email = localStorage.getItem('email');
    if (!email || (window as any).OsmosWidgetLoaded) return;
    const name = `${localStorage.getItem('fname') ?? ''} ${localStorage.getItem('lname') ?? ''}`.trim();
    (async () => {
      try {
        const res = await fetch(
          `https://pm.osmoscloud.com/api/widget/authorized?email=${encodeURIComponent(email)}`,
          { mode: 'cors', credentials: 'omit', cache: 'no-store' }
        );
        if (!res.ok) return;
        const { authorized } = await res.json();
        if (!authorized) return;
        (window as any).OsmosWidgetLoaded = true;
        const s = document.createElement('script');
        s.src = 'https://pm.osmoscloud.com/widget.js';
        s.dataset.key = environment.WIDGET_PUBLIC_KEY;
        s.dataset.reporterEmail = email;
        s.dataset.reporterName = name;
        document.body.appendChild(s);
      } catch {}
    })();
  }
  
  getMerchantProfile(){
    const businessData=JSON.parse(localStorage.getItem('businessDataArr')) ||''
    this.profileInfo = businessData
    // const getMerchantProfileSubs = this.profileService.getMerchantProfile().subscribe((val) => {
    //   this.profileInfo = val.data;      
    // });
  }
 
  tach(){
    this.ComSerService.pinSetScreenWidth(true);
    $('.ico-absolute-2').css('display', 'block');
    $('.col-h').addClass('hover');
    $('.ico-absolute').addClass('hover');
    $('.img-h').addClass('hover');
    $('.p-h').addClass('hover');
    $('.ico-h').addClass('hover');
    $('.text-h').addClass('hover');
    $('.cnt-h').addClass('hover');
    $('.accordion-button').addClass('hover');
    $('.accordion-button::after').addClass('hover');
  }

  noTach(){
    this.ComSerService.pinSetScreenWidth(false);
    $('.ico-absolute-2').css('display', 'none');
    $('.col-h').removeClass('hover');
    $('.ico-absolute').removeClass('hover');
    $('.img-h').removeClass('hover');
    $('.p-h').removeClass('hover');
    $('.ico-h').removeClass('hover');
    $('.text-h').removeClass('hover');
    $('.cnt-h').removeClass('hover');
    $('.accordion-button').removeClass('hover');
    $('.accordion-button::after').removeClass('hover');
  }

  seeChat(){
    $('.cnt-message').css('display', 'block');
    $('.text-sms').css('display', 'none');
  }
  openSideBar(){
    this.openDrawer = !this.openDrawer;
  }
  closeSideBar(){
    this.openDrawer = false;
  }
  receiveDataFromChild(data:boolean) {
    if(data){
      this.openDrawer = !this.openDrawer;
    }
  }
  mouseOver(){
    this.ComSerService.setScreenWidth(true);
  }
  mouseLeave(){
      this.ComSerService.setScreenWidth(false);
  }

}
